import { initBootstrapComponent } from "./utils"

export function init() {
  initBootstrapComponent("popover", { sanitize: false })
}